module.exports = __webpack_public_path__ + "MembersIcon-a1167bad121a3f9d877155cbbb4dc8d0.svg";